import React from "react";
import ReactGA from "react-ga4";

export type Camera = "earth" | "space" | "horizon";

type Props = {
  camera?: Camera;
  setCamera: (newCamera: Camera) => void;
};

const CameraSelect = ({ camera, setCamera }: Props) => {
  return (
    <p className="textBox cell cp_ipselect cp_sl03">
      <select
        value={camera}
        name="camera"
        onChange={(event) => {
          const newCamera = event.target.value;
          ReactGA.event({
            category: "controller",
            action: "camera change",
            label: newCamera,
          });
          if (
            newCamera === "earth" ||
            newCamera === "space" ||
            newCamera === "horizon"
          ) {
            setCamera(newCamera);
          }
        }}
      >
        <option value="earth">地球側</option>
        <option value="horizon">水平線</option>
        <option value="space">宇宙側</option>
      </select>
    </p>
  );
};

export default CameraSelect;
